// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"bc0288c4","95":"bc0288c4","97":"bc0288c4","356":"bc0288c4","366":"bc0288c4","612":"050ab585","825":"bc0288c4","873":"bc0288c4"}[chunkId] + ".chunk.css";
};